import React from 'react'
import { Paper, styled, Card, Typography, Box, Stack, Rating, Button, Divider, Grid, ButtonGroup, Tabs, Tab, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, tableCellClasses, Fade, CardContent, Avatar, CardMedia, useTheme, MobileStepper, Slider, Fab, IconButton, Container, Dialog, DialogTitle, Slide, DialogContent, TextField, DialogActions, InputBase, alpha, FormControl, InputLabel, MenuItem, Select, Snackbar, Alert, useMediaQuery } from '@mui/material'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import banner22 from '../assests/homebg2.jpg';
import Navbar from '../components/Navbar';
import sell from '../assests/Icons/sell.png'
import buy from '../assests/Icons/buy.png'
import consult from '../assests/Icons/consult.png'
import selected from '../assests/Icons/selected.png'
import review from '../assests/review-bunch.webp'
import family from '../assests/family-looking-1.webp'
import zillow from '../assests/rev-zillow.png'
import google from '../assests/rev-google-1.png'
import topCorner from '../assests/topcorner.png'
import bottomCorner from '../assests/bottomcorner.png'
import { blue, deepPurple } from '@mui/material/colors';
import cardImg from '../assests/cardLower.jpg'
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Footer from '../components/Footer';
import CallIcon from '@mui/icons-material/Call';
import { Close, Send } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import MuiAlert from '@mui/material/Alert';
import logo from '../assests/rplogo2.png';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Alert1 = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AlertError = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


const BootstrapInput = styled(InputBase)(({ theme , Matches}) => ({
    width: Matches ? '250px' : '450px',
    'label + &': {
        marginTop: theme.spacing(3),
        color: '#000'
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        textAlign: 'start',
        backgroundColor: theme.palette.mode === 'light' ? '#F4F3F2' : '#1A2027',
        border: '1px solid',
        borderColor: theme.palette.mode === 'light' ? '#F4F3F2' : '#2D3843',
        fontSize: 16,
        width: '100%',
        padding: '5px 12px',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}));

const StyledInput = styled(InputLabel)({
    fontSize: '20px',
    color: '#000',
    fontWeight: 500
});

function SlideTransition(props) {
    return <Slide {...props} direction="up" />;
}


const CustomFab = styled(Fab)(({ theme }) => ({
    position: 'fixed',
    bottom: '5%',
    right: '2%',
    display: 'inline-block',
    textAlign: 'center',
    color: '#005624',
    background: '#978A7D',
    borderRadius: '80px',
    fontSize: '16.5px',
    padding: '0px 0px',
    fontWeight: 700,
    transition: '0.15s',
    marginBottom: ' 0',
    marginRight: 'auto',
    marginTop: '1em',
    textTransform: "none",
    '&:hover': {
        background: '#978A7D',
        border: '1px solid #99cc33'
    }
}))

const CustomBanner = styled(Paper)(({ theme, Matches }) => ({
    background: ` linear-gradient(
        rgb(197 192 192 / 7%), 
        rgb(0 0 0 / 28%)
      ),url(${banner22})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'norepeat',
    backgroundPosition: 'cover cover',
    overflow: 'hidden',
    // padding: 40,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    alignItems: 'start',
    height: 'auto',
    borderRadius: 0,
    marginTop: Matches ? '4em' : '3em'
}))

const StyledPaper = styled(Paper)(({ theme }) => ({
    background: ` linear-gradient(
        rgb(197 192 192 / 7%), 
        rgb(0 0 0 / 28%)
      ),url(${family})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'norepeat',
    backgroundPosition: 'cover cover',
    overflow: 'hidden',
    // padding: 40,
    width: '100%',
    height: '100%',
    alignItems: 'start',
    justifyContent: 'start',
    height: 'auto',
    borderRadius: 0,
}))



const StyledRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
    },
});

const StyledBtn = styled(Button)(({ theme }) => ({
    display: 'inline-block',
    textAlign: 'center',
    color: '#fff',
    background: 'linear-gradient(to right, #2f57ef, #b966e7)',
    borderRadius: '80px',
    fontSize: '14.5px',
    padding: '15px 25px',
    fontWeight: 700,
    transition: '0.15s',
    width: '100%',
    maxWidth: '220px',
    minWidth: '190px',
    marginBottom: ' 0',
    marginRight: 'auto',
    marginTop: '1em',
    textTransform: "none",
    '&:hover': {
        background: 'linear-gradient(to right, #2f57ef, #b966e7)',
        color: '#fff',
    }
}))

const StyledBtn1 = styled(Button)(({ theme, Matches }) => ({
    display: 'inline-block',
    textAlign: 'center',
    color: '#fff',
    background: '#978A7D',
    borderRadius: Matches ? '60px' :'80px',
    fontSize: Matches ? '15.5px' : '16.5px',
    padding: Matches ? '15px' : '15px 25px',
    fontWeight: 700,
    transition: '0.15s',
    width: '100%',
    maxWidth: Matches ? '150px' : '300px',
    minWidth:  Matches ? '250px' : '270px',
    height: Matches ? '55px' :'70px',
    marginBottom: ' 0',
    marginRight: 'auto',
    marginTop: '2em',
    textTransform: "none",
    '&:hover': {
        background: '#444444',
        color: '#fff',
    }
}))

const StyledBtnBuying = styled(Button)(({ theme, Matches }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: '#fff',
    background: '#978A7D',
    borderRadius: '80px',
    fontSize: '14.5px',
    padding: '7px 8px',
    fontWeight: Matches ? 600 : 700,
    transition: '0.15s',
    textTransform: "none",
    width: '100%',
    maxWidth: Matches ? '180px' : '220px',
    minWidth: Matches ? '160px' : '190px',
    marginBottom: '0',
    '&:hover': {
        background: '#444444',
        color: '#fff',
    }
}))

const StyledBtnSelling = styled(Button)(({ theme, Matches }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: '#fff',
    background: '#978A7D',
    borderRadius: '80px',
    fontSize: '14.5px',
    padding: '7px 8px',
    fontWeight: Matches ? 600 : 700,
    transition: '0.15s',
    textTransform: "none",
    width: '100%',
    maxWidth: Matches ? '180px' : '220px',
    minWidth: Matches ? '160px' : '190px',
    marginBottom: ' 0',
    '&:hover': {
        background: '#444444',
        color: '#fff',
    }
}))

const StyledTabs = styled(Tabs)(({ theme }) => ({
    '& .MuiTabs-scroller': {
        transition: 'transform 0.4s',
    },
    '& .MuiTabs-scroller .MuiTabs-scroller-left': {
        transform: 'translateX(100%)',
    },
    '& .MuiTabs-scroller .MuiTabs-scroller-right': {
        transform: 'translateX(100%)',
    },
}))

const StyledTab = styled(Tab)(({ theme, Matches }) => ({
    border: 'none',
    width: Matches ? '150px' : '200px',
    padding: Matches ? '15px' : '20px',
    borderRadius: Matches ? '60px' : "80px",
    boxShadow: 'none',
    fontSize: '16px',
    textTransform: "none",

}))


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.grey,
    },
    [`&.${tableCellClasses.body}`]: {
        borderRight: '1px solid #e9e9e9'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: '#242646',
    },
    [`& .${tooltipClasses.tooltip}`]: {
        width: '200px',
        backgroundColor: '#978A7D',
        color: '#fff',
        textAlign: 'center',
        borderRadius: '6px',
        padding: '5px 10px',
        fontWeight: 400,
        fontSize: '13px',
        transition: '0.15s visibility',
        lineHeight: '1.3em',
    },
}));

const StyledImg = styled('img')(({ theme }) => ({
    width: '25px',
    height: '25px',
    display: 'block',
    margin: '0 auto',
    borderRadius: '60px',
}));

const PrettoSlider = styled(Slider)(({ theme, Matches }) => ({
    color: '#978A7D',
    height: 8,
    width: Matches ? null : '480px',
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 12,
        background: 'unset',
        padding: 0,
        width: 32,
        height: 32,
        borderRadius: '50% 50% 50% 0',
        backgroundColor: '#52af77',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&:before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        },
    },
}));

const AnimatedCallIcon = styled(CallIcon)({
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
        transform: 'rotate(360deg)',
    },
});

function createData(
    name: string,
    calories: string,
    fat: string,
    carbs: number,
    protein: number,
) {
    return { name, calories, fat, };
}



const images = [
    {
        name: 'MJ',
        content: ' A pleasure to work with. They were very responsive and go above and beyond to be sure the clients have all the knowledge to make the best decisions. They attended to every detail throughout the sale of my home. I was able to maximize my return on the sale and will always sell my homes with Real Prop!',
        savings: '$14,345',
    },
    {
        name: 'Samantha F',
        content: 'We had an excellent experience going through Real Prop to purchase our third home (and sell our second one). They recommended really high quality people for things like the house inspection, roofing inspection, and the amount of money we saved on commission fees was ridiculous! We saved thousands of dollars.',
        savings: '$10,430',
    },
    {
        name: 'Rubi H',
        content: 'There are not enough Thank You’s in the world to show our appreciation for the amazing service provided during our sale.You made this so easy! Real Prop is an example to follow in the real estate market.The organization is flawless, and the service is outstanding.',
        savings: '$11,140',
    },
    {
        name: 'Stormie H',
        content: 'Our experience with Real Prop could not have been better! We sold a house and purchased a home simultaneously which was a stressful process but they made it easy to understand, process and go through.',
        savings: '$11,460',
    },
    //     {
    //         name: '',
    //         content: '',
    //         savings: '',
    //     },
];

function SpealDailog(props) {
    const [formData, setFormData] = React.useState({
        name: '',
        email: '',
        phone: '',
        message: '',
    });
    const [errors, setErrors] = React.useState({});
    const [openError, setOpenError] = React.useState(false);
    // const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [isSuccess, setIsSuccess] = React.useState(true);
    const [state, setState] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });

    const { vertical, horizontal, open, } = state;

    const handleSnackbarOpen = (newState) => () => {
        setState({ open: true, ...newState });
    };

    // const handleSnackbarClose = (event, reason) => {
    //     if (reason === 'clickaway') {
    //         return;
    //     }
    //     setState({ ...state, open: false });
    // };

    const handleClickError = () => {
        setOpenError(true);
    };

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handlePhoneInputChange = (e) => {
        const value = e.target.value.replace(/\D/g, ''); // Allow only digits
        setFormData((prevData) => ({
            ...prevData,
            phone: value,
        }));
    };




    const validateFormData = () => {
        const { name, email, phone, message } = formData;

        if (!name || !email || !phone || !message) {
            // At least one field is empty
            return false;
        }

        // Your other validation logic here

        return true;
    };

    const handleSnackbarClose = () => {
        setState({ open: false });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const isFormValid = validateFormData();

        if (isFormValid) {
            // No errors, proceed with form submission
            setIsSuccess(true);
            setState({ open: true, vertical: 'bottom', horizontal: 'right' });
            setFormData({
                name: '',
                email: '',
                phone: '',
                message: '',
            });
            console.log('DATA', formData);
        } else {
            // Error in form submission
            setIsSuccess(false);
            setState({ open: true, vertical: 'bottom', horizontal: 'right' });
        }

        // Open the Snackbar

    };

    return (
        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={props.open}
            TransitionComponent={Transition}
            sx={{ width: '100%' }}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Contact our Team
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={props.close}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Close />
            </IconButton>
            <DialogContent dividers>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2} sx={{ p: props.Matches ? '1em' : '1em 3em' }}>
                        <Grid item xs={12}>
                            <FormControl variant="standard">
                                <StyledInput shrink htmlFor="bootstrap-input" >Name</StyledInput>
                                <BootstrapInput
                                    label="Name"
                                    fullWidth
                                    name="name"
                                    type="text"
                                    required
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    size="small"
                                    error={!!errors.name}
                                    helperText={errors.name}
                                    Matches={props.Matches}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="standard">
                                <StyledInput shrink htmlFor="bootstrap-input" >Email</StyledInput>
                                <BootstrapInput
                                    label="Email"
                                    fullWidth
                                    type="email"
                                    name="email"
                                    required
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    Matches={props.Matches}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="standard">
                                <StyledInput shrink htmlFor="bootstrap-input" >Phone Number</StyledInput>
                                <BootstrapInput
                                    label="Phone"
                                    fullWidth
                                    name="phone"
                                    required
                                    value={formData.phone}
                                    onChange={handlePhoneInputChange}
                                    Matches={props.Matches}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="standard">
                                <StyledInput shrink htmlFor="bootstrap-input" >Message</StyledInput>
                                <BootstrapInput
                                    fullWidth
                                    multiline
                                    rows={4}
                                    name="message"
                                    required
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    Matches={props.Matches}
                                />
                            </FormControl>

                        </Grid>
                    </Grid>
                    <DialogActions>
                        <Button sx={{
                            mr: '2em',
                            color: '#fff',
                            background: '#978A7D',
                            textTransform: 'capitalize'
                        }}
                            type="submit"
                            endIcon={<Send />}
                        >Send</Button>
                        <Snackbar
                            open={open}
                            autoHideDuration={4000}
                            onClose={handleSnackbarClose}
                        >
                            <Alert
                                onClose={handleSnackbarClose}
                                severity={isSuccess ? 'success' : 'error'}
                                variant="filled"
                            >
                                {isSuccess
                                    ? 'Form submitted successfully!'
                                    : 'Please fill in all fields.'}
                            </Alert>
                        </Snackbar>
                    </DialogActions>
                </form>
            </DialogContent>
        </BootstrapDialog>
    )

}

const savings = [
    {
        number: '$12,000',
        content: 'Average Buyer & Seller Savings!'
    },
    {
        number: '$68 Million',
        content: 'Saved, From Coast To Coast'
    },
    {
        number: '98%',
        content: 'Listing To Selling Price Accuracy'
    },
]


const Home = () => {
    const theme = useTheme();
    const history = useNavigate();
    const matches = useMediaQuery('(max-width:600px)');
    const [selectedButton, setSelectedButton] = React.useState(0);
    const [activeStep, setActiveStep] = React.useState(0);
    const [pamount, setPamount] = React.useState(250000);
    const [isVisible, setIsVisible] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const maxSteps = images.length;
    const formattedNumber = new Intl.NumberFormat('en-US').format(pamount);
    const maxValue = 2000000;
    const PhoneNumber = '+1234567890';

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepChange = (step: number) => {
        setActiveStep(step);
    };
    const handleChange = (event, newValue) => {
        setSelectedButton(newValue);
    };

    const openWhatsAppChat = () => {
        const phoneNumber = '+14255333269'; // Replace with the desired phone number
        const whatsappUrl = `https://wa.me/${phoneNumber}`;

        window.open(whatsappUrl, '_blank');
    };

    const handleScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > 0) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };


    const rows = [
        createData('Seller agent commission',
            <BootstrapTooltip arrow
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 600 }}
                title="On a $500,000 home this could cost you $15,000. Our 1% fee can save you $10,000!" placement="top" >
                <Typography sx={{ fontSize: matches ? '13px' : null, textDecoration: 'underline 3px dotted grey', }}>3% </Typography>
            </BootstrapTooltip>,
            <BootstrapTooltip arrow
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 600 }}
                title="You don't pay anything up front. We only get paid when you do!" placement="top" >
                <Typography sx={{ fontSize: '1.04em', fontWeight: 500, textDecoration: 'underline 3px dotted grey', }}>1% </Typography>
            </BootstrapTooltip>),
        createData('Average # of homes sold per year', '6-12', '100+'),
        createData('Average charge for a $500k home', '$15,000', '$5,000'),
        createData('7-day-a-week availability', '', <StyledImg src={selected} alt="Select" />),
        createData('Experienced negotiators', '', <StyledImg src={selected} alt="Select" />),
        createData('Facilitate multiple cash offers', '', <StyledImg src={selected} alt="Select" />),
        createData('A team of full-time licensed agents', '', <StyledImg src={selected} alt="Select" />),
        createData('Proprietary software to stay organized', '', <StyledImg src={selected} alt="Select" />),
        createData('',),
    ];
    
    const rows1 = [
        createData('Cash back at closing', '$0',
            <BootstrapTooltip arrow
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 600 }}
                title="You get $2,500 when you bundle mortgage and title!" placement="top" >
                <Typography sx={{ fontSize: '1.04em', fontWeight: 500, textDecoration: 'underline 3px dotted grey', }}>$2,500 </Typography>
            </BootstrapTooltip>),
        createData('Unlimited private showings', <StyledImg src={selected} alt="Select" />, <StyledImg src={selected} alt="Select" />),
        createData('Experienced negotiators', <StyledImg src={selected} alt="Select" />, <StyledImg src={selected} alt="Select" />),
        createData('Multiple Cash Offers', '', <StyledImg src={selected} alt="Select" />),
        createData('7-day-a-week availability', '', <StyledImg src={selected} alt="Select" />),
        createData('A team of full-time licensed agents', '', <StyledImg src={selected} alt="Select" />),
        createData('Proprietary software to stay organized', '', <StyledImg src={selected} alt="Select" />),
        createData('',),
    ];



    window.addEventListener('scroll', handleScroll);
    const Items = selectedButton === 1 ? rows1 : rows
    return (
        <div>
            <CustomFab
                size="medium"
                color="primary"
                aria-label="Scroll to top"
                style={{ display: isVisible ? 'block' : 'none' }}
                onClick={openWhatsAppChat}
            >
                <IconButton size="small" sx={{
                    background: '#978A7D', color: '#fff',
                    '&:hover': {
                        background: '#444444',
                    }
                }} >
                    <AnimatedCallIcon sx={{ color: '#fff' }} />
                </IconButton>
            </CustomFab>
            <CustomBanner elevation={0} Matches={matches}>
                {/* <Navbar /> */}
                <Box sx={{
                    m: matches ? '5em 2em' : '10em', display: 'flex', flexDirection: 'column', justifyContent: 'center',
                }}>
                    <Stack spacing={1} display="flex" justifyContent="center" alignItems="center" sx={{
                        p: matches ? '2em 1em' : '3em 5em',
                        bgcolor: '#EFE8E5',
                        borderRadius: '10px',
                    }}>
                        <Typography variant='h4' component="div" sx={{
                            fontSize: matches ? '22px' : null,
                            fontWeight: matches ? 600 : null,
                            letterSpacing: '-0.03em',
                        }}>
                            {/* Full Service <span style={{
                                color: 'transparent', // Make the text color transparent
                                backgroundImage: 'linear-gradient(to right, #2f57ef, #b966e7)', // Gradient colors
                                WebkitBackgroundClip: 'text', // Clip text to the background gradient
                                position: 'relative',
                            }}>Realty</span> For Thousands Less */}
                            Experience comprehensive services with the most significant buyer rebates and the lowest selling fees
                        </Typography>
                        <Typography variant="h5" textTransform="uppercase" sx={{
                            fontSize: matches ? '14px' : null,
                            fontWeight: matches ? 500 : null,
                            color: '#978A7D'
                        }}>
                            Flat fee models for buying and selling homes in WA state
                        </Typography>
                        <Stack direction="row" spacing={0} sx={{ p: '5px' }}>
                            <StyledRating sx={{ mt: '4px' }} name="half-rating-read" defaultValue={5} readOnly size="medium" />
                            <Typography variant="body1" sx={{
                                padding: matches ? '5px 0 0 10px' : '5px 0 0 20px',
                                fontSize: matches ? '12px' : null,
                                fontWeight: 500,
                                color: '#555',
                            }}>5 Stars | 650+ Reviews on Google</Typography>
                        </Stack>
                    </Stack>
                    <Stack spacing={3} sx={{ p: '2em' }}
                        direction={matches ? "column" : "row"} display="flex" justifyContent="center" alignItems="center">
                        <StyledBtnBuying Matches={matches} onClick={() => history(`/Buy`)}>Buy</StyledBtnBuying>
                        <StyledBtnSelling Matches={matches} onClick={() => history(`/Sell`)}>Sell</StyledBtnSelling>
                    </Stack>
                </Box>

            </CustomBanner>
            <Paper elevation={0} sx={{ display: 'flex', justifyContent: 'center', bgcolor: '#FAFAFA', }}>
                <Stack direction={matches ? "column" : "row"} spacing={matches ? 0 : 2} divider={matches ? null : <Divider orientation="vertical" flexItem />} sx={{ p: matches ? '2em' : '4em 18em' }}>
                    <Stack direction="row" spacing={matches ? 1 : 1}>
                        <img src={sell} alt="sellimg" width={matches ? "25%" : "51px"} height={matches ? "75%" : null} />
                        <Typography variant={matches ? "h7" : 'h6'} sx={{
                            pt: matches ? '10px' : '10px',
                            lineHeight: '1.4em',
                            textAlign: 'left',
                        }}>
                            Sellers save an average of $7,500 in commission fees
                        </Typography>
                    </Stack>
                    <Stack direction="row" spacing={matches ? 1 : 1}>
                        <img src={buy} alt="buyimg" width={matches ? "25%" : "51px"} height={matches ? "75%" : null} />
                        <Typography variant={matches ? "h7" : 'h6'} sx={{
                            pt: matches ? '10px' : '10px',
                            lineHeight: '1.4em',
                            textAlign: 'left',
                        }}>
                            Buyers get $2,500 cash back when they bundle mortgage and title
                        </Typography>
                    </Stack>
                    <Stack direction="row" spacing={matches ? 1 : 1}>
                        <img src={consult} alt="consultimg" width={matches ? "25%" : "51px"} height={matches ? "75%" : null} />
                        <Typography variant={matches ? "h7" : 'h6'} sx={{
                            pt: matches ? '10px' : '10px',
                            lineHeight: '1.4em',
                            textAlign: 'left',
                        }}>
                            Get Free Consultations, Home Valuations, & Showings
                        </Typography>
                    </Stack>
                </Stack>
            </Paper>
            <Paper elevation={0} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', p: matches ? '2em' : '5em 25em' }}>
                <Typography variant='h4' gutterBottom sx={{
                    fontSize: matches ? '22px' : null,
                    fontWeight: matches ? 600 : null,
                    letterSpacing: '-0.03em',
                }}>
                    We make real estate simple, safe, and affordable.
                </Typography>
                <Typography variant={matches ? "h7" : 'h6'} >
                    Real Prop is an affordable full-service real estate agency. When you work with us, you get best-in-class customer service and a team of expert agents that closes hundreds of deals per year.
                </Typography>
            </Paper>
            <Divider />
            <Container maxWidth="xl">
                <Paper elevation={0} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', p: matches ? '2em 1em' : '5em 14em' }}>
                    <Grid container spacing={1}>
                        <Grid item xs={matches ? 12 : 6}>
                            <Typography variant='h4' gutterBottom sx={{
                                fontSize: matches ? '22px' : null,
                                fontWeight: matches ? 600 : null,
                                letterSpacing: '-0.03em',
                                textAlign: 'left'
                            }}>How we compare to traditional agents </Typography>
                        </Grid>
                        <Grid item xs={matches ? 12 : 6} display="flex" justifyContent={matches ? "center" : "start"}>
                            <Box
                                display="flex"
                                justifyContent={matches ? "center" : "start"}
                                alignItems={matches ? "center" : "start"}
                                border="1px solid #e9e9e9"
                                borderRadius="80px"
                                width={matches ? null : "400px"}
                                height={matches ? "50px" : "60px"}
                            >
                                <StyledTabs
                                    value={selectedButton}
                                    onChange={handleChange}
                                    variant="fullWidth"
                                    indicatorColor="none"
                                >
                                    <StyledTab Matches={matches} label="Selling" style={{
                                        background: selectedButton === 0 ? '#978A7D' : 'transparent',
                                        color: selectedButton === 0 ? '#fff' : '#666',
                                    }} />
                                    <StyledTab Matches={matches} label="Buying" style={{
                                        background: selectedButton === 1 ? '#978A7D' : 'transparent',
                                        color: selectedButton === 1 ? '#fff' : '#666',
                                    }} />
                                </StyledTabs>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Container maxWidth={matches ? "xxl" : "xl"}>
                                <TableContainer component={Paper} elevation={0} sx={{ borderRadius: '0px' }}>
                                    <Table sx={{ minWidth: '100%', }} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell></StyledTableCell>
                                                <TableCell align="center" sx={{
                                                    color: '#666 ',
                                                    fontWeight: '500 ',
                                                    border: '1px solid #e9e9e9',
                                                    borderRadius: '10px 0px 0 0',
                                                }}>Traditional Agent</TableCell>
                                                <TableCell align="center" sx={{
                                                    color: '#666 ',
                                                    fontWeight: '500 ',
                                                    border: '1px solid #e9e9e9',
                                                }}><Box
                                                        component="img"
                                                        sx={{
                                                            height: matches ? 50 : 110, // Adjust the height as needed
                                                            width: matches ? 100 : 150, // This will maintain the aspect ratio
                                                            mt: 1,
                                                            mb: 0
                                                        }}
                                                        alt="Logo"
                                                        src={`${logo}`} // Replace with the path to your logo
                                                        onClick={() => history(`/`)}
                                                    /></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Items.map((row) => (
                                                <StyledTableRow key={row.name}>
                                                    {
                                                        (row.name) === '' ? null :
                                                            <>
                                                                <StyledTableCell component="th" scope="row" sx={{
                                                                    fontSize: matches ? '13px' : '1em',
                                                                    width: matches ? '300px' : '500px',
                                                                    padding: matches ? '8px' : '15px 10px 15px 15px',
                                                                    color: '#000 ',
                                                                    letterSpacing: '-0.015em',
                                                                    fontWeight: 500,
                                                                    borderLeft: '1px solid #e9e9e9',
                                                                }}>
                                                                    {row.name}
                                                                </StyledTableCell>
                                                                <StyledTableCell align="center" sx={{
                                                                    fontSize: matches ? '13px' : '1em',
                                                                    width: matches ? '50px' : '150px',
                                                                    padding: matches ? '8px' : null,
                                                                    color: '#6a6a6a',
                                                                    letterSpacing: '-0.015em',
                                                                    fontWeight: 400,
                                                                }}>{row.calories}</StyledTableCell>
                                                                <StyledTableCell align="center" sx={{
                                                                    fontSize: matches ? '13px' : '1.04em',
                                                                    width: matches ? '50px' : '150px',
                                                                    padding: matches ? '8px' : null,
                                                                    color: '#000',
                                                                    letterSpacing: '-0.015em',
                                                                    fontWeight: 500,
                                                                    borderLeft: '1px solid #e9e9e9',
                                                                }}>{row.fat}</StyledTableCell>
                                                            </>
                                                    }

                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Container>
                        </Grid>
                    </Grid>
                </Paper>
            </Container>
            {/* <Paper elevation={0} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', p: '3em 25em' }}>
                <Typography variant='h3' gutterBottom sx={{ fontWeight: 500 }}>
                    See why thousands of home buyers and sellers choose Real Prop
                </Typography>
            </Paper>
            <Paper elevation={0} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', m: '1em 5em' }}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <img src={review} alt="Review img" height="500px" />
                    </Grid>
                    <Grid item xs={6} sx={{ mt: '2.5em' }}>
                        <SwipeableViews
                            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                            index={activeStep}
                            onChangeIndex={handleStepChange}
                            enableMouseEvents
                        >
                            {images.map((step, index) => (
                                <div key={step.name}>
                                    {Math.abs(activeStep - index) <= 2 ? (
                                        <Card sx={{
                                            width: '450px',
                                            background: 'linear-gradient(to right, #1BA1F2, #3B5997)',
                                            border: '1px solid #e9e9e9',
                                            boxShadow: '0 5px 15px -2px rgba(0,0,0,0.1)',
                                            borderRadius: '16px',
                                            display: ' flex',
                                            alignItems: 'center',
                                            justifyCntent: 'center',
                                            padding: '35px 35px',
                                            position: 'relative',
                                            color: '#fff',
                                            fontFamily: "'DM Sans', 'Helvetica', 'Arial', 'Lucida', sans-serif",
                                        }}>
                                            <CardContent>
                                                <Typography sx={{ fontSize: '17px', fontWeight: 500 }}>
                                                    {step.content}
                                                </Typography>
                                                <Grid container spacing={0} sx={{ mt: '2em' }}>
                                                    <Grid item xs={2.5}>
                                                        <Avatar sx={{ bgcolor: blue[900], width: 60, height: 60, fontSize: '2em' }}>{step.name.charAt[0]}</Avatar>
                                                    </Grid>
                                                    <Grid item xs={3.5} display="flex" flexDirection="column" justifyContent="center" alignItems="start">
                                                        <Typography sx={{
                                                            mb: '1px', fontSize: '1.3em',
                                                            fontWeight: 800,
                                                            textAlign: 'left',
                                                            color: '#6633cc'
                                                        }}>{step.name}</Typography>
                                                        <Typography sx={{
                                                            fontSize: '15px',
                                                            fontWeight: 600,
                                                            textAlign: 'left',
                                                            color: '#fff'
                                                        }}>Saved {step.savings}</Typography>
                                                    </Grid>
                                                    <Grid item xs={4} display="flex" justifyContent="start" alignItems="center">
                                                        <Rating name="read-only" value={5} readOnly />
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                            {/* <CardMedia
                                                component="img"
                                                alt="cardLower"
                                                image={cardImg}
                                                sx={{
                                                    display: 'block',
                                                    content: '""',
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    right: 0,
                                                    width: '140px',
                                                    height: '120px',
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'left top',
                                                    borderRadius: '0 0 16px 0',
                                                    opacity: 0.6,
                                                }}
                                            /> *
                                        </Card>
                                    ) : null}
                                </div>
                            ))}
                        </SwipeableViews>
                        <MobileStepper
                            variant="dots"
                            steps={maxSteps}
                            position="static"
                            activeStep={activeStep}
                            sx={{
                                mt: '1em',
                                width: '500px'
                            }}
                            nextButton={
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    onClick={handleNext}
                                    disabled={activeStep === maxSteps - 1}
                                    sx={{
                                        color: '#8d8989',
                                        fontSize: '14px',
                                        background: 'none',
                                        border: '1px solid #efefef',
                                        '&:hover': {
                                            background: 'none',
                                            color: '#8d8989',
                                            borderColor: '#8d8989',
                                        }
                                    }}
                                >
                                    Next
                                    {theme.direction === 'rtl' ? (
                                        <KeyboardArrowLeft />
                                    ) : (
                                        <KeyboardArrowRight />
                                    )}
                                </Button>
                            }
                            backButton={
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    onClick={handleBack}
                                    disabled={activeStep === 0}
                                    sx={{
                                        color: '#8d8989',
                                        fontSize: '14px',
                                        background: 'none',
                                        border: '1px solid #efefef',
                                        '&:hover': {
                                            backgroundColor: 'none',
                                            color: '#8d8989',
                                            borderColor: '#8d8989',
                                        }
                                    }}
                                >
                                    {theme.direction === 'rtl' ? (
                                        <KeyboardArrowRight />
                                    ) : (
                                        <KeyboardArrowLeft />
                                    )}
                                    Prev
                                </Button>
                            }
                        />
                    </Grid>
                </Grid>
            </Paper> */}
            <Paper elevation={0} sx={{ mt: '2em', }}>
                {/* <Divider />
                <Grid container spacing={0}>
                    <Grid item xs={5}>
                        <img src={family} alt="family"
                            style={{
                                display: 'flex',
                                width: '95%'
                            }} />
                    </Grid>
                    <Grid item xs={7} display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ p: '0em 9em' }}>
                        <Typography gutterBottom sx={{ fontSize: '3em', fontWeight: 500, textAlign: 'center', lineHeight: 1 }}>
                            The difference is in the details
                        </Typography>
                        {
                            savings.map((item) => {
                                return (
                                    <>
                                        <Grid item sx={{ mt: '2em' }} key={item.number}>
                                            <Typography
                                                sx={{
                                                    fontSize: '3em',
                                                    fontWeight: 500,
                                                }}
                                            >{item.number}</Typography>
                                            <div
                                                style={{
                                                    background: 'linear-gradient(to right, #2f57ef, #b966e7)', // Linear gradient color
                                                    height: '10px', // Adjust height as needed
                                                    width: '100%', // Adjust width as needed
                                                    marginTop: '-1.4em',// Add space between Typography and border
                                                }}
                                            ></div>

                                        </Grid>
                                        <Grid item sx={{ mt: '5px' }}>
                                            <Typography sx={{ fontSize: 16, fontWeight: 400 }} color="text.secondary" gutterBottom>
                                                {item.content}
                                            </Typography>
                                        </Grid>
                                    </>
                                )
                            })
                        }

                    </Grid>
                </Grid> */}
                <Divider />
                <Container maxWidth="xl">
                    <Paper elevation={0} sx={{ p: matches ? '2em 1em' : '5em 15em', }}>
                        <Card sx={{ borderRadius: '30px', }}>
                            <Grid container spacing={5} sx={{ p: matches ? '2em' : '3em 5em' }}>
                                <Grid item xs={matches ? 12 : 4} display="flex" flexDirection="column" justifyContent="start" alignItems="start">
                                    <Typography variant="h6">Total Savings:</Typography>
                                    <Grid item xs display='flex' flexDirection="row">
                                        <Typography variant="h5" sx={{ mr: '2px' }} onChange={(event, value) => setPamount(value)}>
                                            $
                                        </Typography>
                                        <Typography variant={matches ? "h4" : "h3"} onChange={(event, value) => setPamount(value)}>
                                            {formattedNumber}
                                        </Typography>
                                    </Grid>
                                    <Typography sx={{ fontSize: 15, fontWeight: 400, color: '#242646', textAlign: 'left', mb: matches ? null : '3em' }}>* Commissions vary based on market conditions and location</Typography>
                                </Grid>
                                <Grid item xs={matches ? 12 : 8} display="flex" flexDirection="column" justifyContent="start" alignItems="center">
                                    <Grid item xs sx={{ mb: '0.8em' }}>
                                        <Typography variant="h4" sx={{
                                            fontSize: matches ? '22px' : null,
                                            fontWeight: matches ? 600 : null,
                                            letterSpacing: '-0.03em',
                                            textAlign: 'left'
                                        }}>How much can Real Prop save you?</Typography>
                                    </Grid>
                                    {matches ?
                                        <Grid item xs display='flex' flexDirection="row" sx={{ mb: '0.8em' }}>
                                            <Typography sx={{ fontSize: '1em', fontWeight: 400, color: '#242646', mr: 3 }} onChange={(event, value) => setPamount(value)}>
                                                Estimated home price?
                                            </Typography>
                                            <Typography sx={{ fontSize: 18, fontWeight: 500, color: '#242646', mr: '2px' }} onChange={(event, value) => setPamount(value)}>
                                                $
                                            </Typography>
                                            <Typography sx={{ fontSize: '1.4em', fontWeight: 600, color: '#242646' }} onChange={(event, value) => setPamount(value)}>
                                                {formattedNumber}
                                            </Typography>
                                        </Grid>
                                        :
                                        <Grid item xs display='flex' flexDirection="row" sx={{ mb: '0.8em' }}>
                                            <Typography sx={{ fontSize: '1.2em', fontWeight: 400, color: '#242646', mr: '9.8em' }} onChange={(event, value) => setPamount(value)}>
                                                Estimated home price?
                                            </Typography>
                                            <Typography sx={{ fontSize: 18, fontWeight: 500, color: '#242646', mr: '2px' }} onChange={(event, value) => setPamount(value)}>
                                                $
                                            </Typography>
                                            <Typography sx={{ fontSize: '1.4em', fontWeight: 600, color: '#242646' }} onChange={(event, value) => setPamount(value)}>
                                                {formattedNumber}
                                            </Typography>
                                        </Grid>}

                                    <PrettoSlider aria-label="pretto slider" Matches={matches} value={typeof pamount === 'number' ? pamount : 0} onChange={(event, vAmt) => { setPamount(vAmt) }} max={maxValue} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={matches ? 2 : 5} sx={{ backgroundColor: '#F4F3F2', p: matches ? '1em' : '0em 6em 2em 6em' }}>
                                <Grid item xs={matches ? 12 : 6} display='flex' flexDirection="row" justifyContent="start" alignItems="center">
                                    <Typography sx={{ fontSize: matches ? 18 : 20, fontWeight: 500, color: '#242646' }}>Seller saves:</Typography>
                                    <Grid item xs display='flex' flexDirection="column" sx={{
                                        ml: matches ? '1.3em': '1.8em',
                                        borderLeft: 'ridge'
                                    }}>
                                        <Grid item xs display='flex' flexDirection="row" sx={{ ml: '1.8em' }}>
                                            <Typography sx={{ fontSize: 18, fontWeight: 500, color: '#242646', }} onChange={(event, value) => setPamount(value)}>
                                                $
                                            </Typography>
                                            <Typography sx={{ fontSize: matches ? '1.5em' : '2em', fontWeight: 600, color: '#242646' }} onChange={(event, value) => setPamount(value)}>
                                                {formattedNumber}
                                            </Typography>
                                        </Grid>
                                        <Typography sx={{ fontSize: matches ? 14 : 15, fontWeight: 400, color: '#242646', ml: '2em', textAlign: matches ? 'start' : 'justify' }}>Average sellers commission is 3%.* This would be $30,600. At Real Prop we only charge one low fee.</Typography>
                                    </Grid>
                                </Grid>
                                <Grid item xs={matches ? 12 : 6} display='flex' flexDirection="row" justifyContent="start" alignItems="center">
                                    <Typography sx={{ fontSize: matches ? 18 : 20, fontWeight: 500, color: '#242646' }}>Buyers get:</Typography>
                                    <Grid item xs display='flex' flexDirection="column" sx={{
                                        ml: matches ? '1.9em':'1.8em',
                                        borderLeft: 'ridge'
                                    }}>
                                        <Grid item xs display='flex' flexDirection="row" sx={{ ml: '1.8em' }}>
                                            <Typography sx={{ fontSize: 18, fontWeight: 500, color: '#242646', }} onChange={(event, value) => setPamount(value)}>
                                                $
                                            </Typography>
                                            <Typography sx={{ fontSize: matches ? '1.5em' : '2em', fontWeight: 600, color: '#242646' }} onChange={(event, value) => setPamount(value)}>
                                                {formattedNumber}
                                            </Typography>
                                        </Grid>
                                        <Typography sx={{ fontSize: matches ? 14 : 15, fontWeight: 400, color: '#242646', ml: '2em', textAlign: matches ? 'start' : 'justify' }}>Average sellers commission is 3%.* This would be $30,600. At Real Prop we only charge one low fee.</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Card>
                    </Paper>
                </Container>
            </Paper>
            <Divider />
            <Paper elevation={0} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                {
                    matches ?
                        <Grid container display="flex" flexDirection="column" spacing={2} sx={{ p: matches ? '2em 1em' : '3em 0em' }}>
                            <Grid item xs={6}>
                                <img src={topCorner} alt="img" width={matches ? "150px" : "250px"} height={matches ? "150px" : "250px"}
                                    style={{
                                        display: 'block',
                                        position: 'absolute',
                                        right: '2%',

                                    }} />
                            </Grid>
                              <Grid item xs={12} display='flex' flexDirection='column' justifyContent="center" alignItems="center" sx={{ mt: '5em' }}>
                                <Typography variant="h4" gutterBottom sx={{
                                    width: '100%',
                                    fontSize: matches ? '22px' : null,
                                    fontWeight: matches ? 600 : null,
                                    letterSpacing: '-0.03em',
                                    textAlign: 'center'
                                }}>
                                    Get a free, no-obligation consultation today!
                                </Typography>
                                <Stack display="flex" justifyContent="center">
                                    <StyledBtn1 variant="container" onClick={handleClickOpen} Matches={matches} >
                                        Speak with an Agent
                                    </StyledBtn1>
                                    <SpealDailog open={open} close={handleClose} Matches={matches}/>
                                </Stack>
                                <Stack display="flex" justifyContent="center" direction="row" sx={{ m: '1em 0 5em 0' }}>
                                    <img src={zillow} alt="Zillow" width="150px" height="80px" />
                                    <img src={google} alt="Google" width="150px" height="80px" />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} display='flex' justifyContent="end" alignItems="end">
                                <img src={bottomCorner} alt="img" width={matches ? "150px" : "250px"} height={matches ? "150px" : "250px"}
                                    style={{
                                        display: 'block',
                                        position: 'absolute',
                                        left: '2%',
                                        transform: 'rotate(180deg)',
                                    }} />
                            </Grid>
                        </Grid>
                        :
                        <Grid container spacing={2} sx={{ p: matches ? '2em 1em' : '3em 0em' }}>
                            <Grid item xs={matches ? 2 : 4} display='flex' justifyContent="end" alignItems="end">
                                <img src={bottomCorner} alt="img" width={matches ? "150px" : "250px"} height={matches ? "150px" : "250px"}
                                    style={{
                                        display: 'block',
                                        position: 'absolute',
                                        left: '2%',
                                        transform: 'rotate(180deg)',
                                    }} />
                            </Grid>
                            <Grid item xs={matches ? 8 : 4} display='flex' flexDirection='column' justifyContent="center" alignItems="center" sx={{ mt: '1em' }}>
                                <Typography variant="h4" gutterBottom sx={{
                                    width: '100%',
                                    fontSize: matches ? '22px' : null,
                                    fontWeight: matches ? 600 : null,
                                    letterSpacing: '-0.03em',
                                    textAlign: 'left'
                                }}>
                                    Get a free, no-obligation consultation today!
                                </Typography>
                                <Stack display="flex" justifyContent="center">
                                    <StyledBtn1 variant="container" onClick={handleClickOpen} Matches={matches}>
                                        Speak with an Agent
                                    </StyledBtn1>
                                    <SpealDailog open={open} close={handleClose} />
                                </Stack>
                                <Stack display="flex" justifyContent="center" direction={matches ? "column" : "row"} sx={{ mt: '5em' }}>
                                    <img src={zillow} alt="Zillow" width={matches ? "150px" : null} height={matches ? "150px" : null} />
                                    <img src={google} alt="Google" width={matches ? "150px" : null} height={matches ? "150px" : null} />
                                </Stack>
                            </Grid>
                            <Grid item xs={matches ? 2 : 4}>
                                <img src={topCorner} alt="img" width={matches ? "150px" : "250px"} height={matches ? "150px" : "250px"}
                                    style={{
                                        display: 'block',
                                        position: 'absolute',
                                        right: '2%',

                                    }} />
                            </Grid>
                        </Grid>
                }

            </Paper>
            <Divider />
        </div >
    )
}

export default Home